import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import QiwaContractTab from "./QiwaContractTab/QiwaContractTab";
import QiwaContractRenewal from "./QiwaContractRenewal/QiwaContractRenewal";
import QiwaPopUp from "./QiwaPopUp";

export default function QiwaContract() {
  //screen Title Show fun
  const dispatch = useDispatch();
  const titleBorder = [
    { label: "qiwa Contract", link: "/dashboard/qiwa-Contract" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [index, setIndex] = useState(0);

  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`p-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            className={`p-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
            onClick={() => handleIndex(0)}
          >
            QIWA CONTRACT
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            QIWA CONTRACT RENEWAL
          </button>
        </div>
        {index === 0 ? (
          <QiwaContractTab />
        ) : index === 1 ? (
          <QiwaContractRenewal />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
